export enum QuestionType {
  RadioButtonQuestion = 'interviewRadioButtonQuestion',
  CategoryQuestion = 'interviewCategoryQuestion',
  RadioImageQuestion = 'interviewRadioImageQuestion',
  RadioButtonThemeQuestion = 'interviewRadioButtonThemeQuestion',
  RichTextQuestion = 'interviewRichTextQuestion',
  TextQuestion = 'interviewTextQuestion',
  NameQuestion = 'interviewNameQuestion',
  CalendarQuestion = 'interviewCalendarQuestion',
  UploadFilesQuestion = 'interviewFileUploadQuestion',
  UploadMultipleFilesComponent = 'interviewUploadMultipleFilesComponent',
  EmailQuestion = 'interviewEmailQuestion',
  PhoneQuestion = 'interviewPhoneNumberQuestion',
  CheckboxQuestion = 'interviewCheckboxQuestion',
  LocationQuestion = 'interviewLocationQuestion',
  DropDownQuestion = 'interviewDropDownQuestion',
}
